import i18n from 'i18next';
import Axios from 'axios';
import Configuration from './Configuration';
import DataSource from './DataSource';

const errorNoResponseMessage = i18n.t("Η υπηρεσία δεν είναι διαθέσιμη αυτή τη στιγμή. Παρακαλώ επικοινωνήστε με την υποστήριξη πελατών");

class SessionManager
{
    static userDescription() {

        if (localStorage.hasOwnProperty('userData')) {
            return JSON.parse(localStorage.getItem('userData')).description;
        }
        else
            return i18n.t('Άγνωστος Χρήστης');
    }

    static get userName() {
        if (localStorage.hasOwnProperty('userData')) {
            return JSON.parse(localStorage.getItem('userData')).name;
        }
        else
            return '';
    }

    static get userId() {
        if (localStorage.hasOwnProperty('userData')) {
            return JSON.parse(localStorage.getItem('userData')).id;
        }
        else
            return '';
    }

    static get salesPointId() {
        if (localStorage.hasOwnProperty('userData')) {
            return JSON.parse(localStorage.getItem('userData')).salesPointId;
        }
        else
            return '';
    }

    static get customerAccountId() {
        if (localStorage.hasOwnProperty('userData')) {
            return JSON.parse(localStorage.getItem('userData')).customerAccountId;
        }
        else
            return '';
    }

    static get defaultCurrency() {
        return 'EUR';
    }

    static get currency() {
        
        var currency = null;

        if (localStorage.hasOwnProperty('userData')) {
            currency = JSON.parse(localStorage.getItem('userData')).defaultCurrency;
        }
        
        return currency? currency : SessionManager.defaultCurrency;
    }

    static get defaultLanguage() {
        return 'el';
    }

    static get language() {

        var nls = null;

        if (localStorage.hasOwnProperty('userData')) {
            nls = JSON.parse(localStorage.getItem('userData')).defaultLanguage;
        }

        return nls? nls : SessionManager.defaultLanguage;
    }
    
    //Check if the user is Logged In
    static get isUserLoggedIn() {
        return localStorage.hasOwnProperty('userData') ? true : false;
    }

    static get isUserAdmin() {

        var adminRole = JSON.parse(localStorage.getItem('userData'));

        if (adminRole && adminRole.hasOwnProperty('userRole') && adminRole.userRole === "admin")
            return true;
        else
            return false;

    }

    static get userToken() {
        return localStorage.hasOwnProperty('userToken') ? JSON.parse(localStorage.getItem('userToken')).token : '';
    }

    static get userRefreshToken() {
        return localStorage.hasOwnProperty('userToken') ? JSON.parse(localStorage.getItem('userToken')).refreshToken : '';
    }


    static async login(_userName, _password) {
        
        const url = CreatePostUrl(
            /* controller */            'login',
            /* connectionName */        Configuration.connectionName,
            /* version */               Configuration.version,
            /* entityName */            null,
            /* authenticationToken */   null,
            /* username */              null);

        try {
            var response = await Axios.post(url, { username: _userName, password: SessionManager.hashPassword(_password) });

            if (response.data != null) {

                localStorage.setItem('userToken', response.data);
                var user = await DataSource.load('User', _userName, { userName: _userName, associations: 'Roles' })

                var spData = await loadSalesPointinfo(user);

                let userData = {
                    name: user.UserName,
                    id: user.UserId,
                    description: user.Description,
                    salesPointId: spData ? spData.OrganizationId : null,
                    salesPointName: spData ? spData.Description : null,
                    customerAccountId: spData ? spData.CustomerAccountId : null,
                    userRole: isAdmin(user)
                };

                localStorage.setItem('userData', JSON.stringify(userData));
                localStorage.setItem('lastActiveTime', new Date());
            }
        }

        catch (error) {
            
            var message = getErrorMessageFromResponse(error);
            throw new Error(message);

        }
    }

    static logout() {        
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
    }

    static expiredToken() {
        SessionManager.logout();
        window.location.href = '/login';
    }

    static hashPassword(password) {

        var CryptoJs = require('crypto-js');

        var pwdHash = CryptoJs.SHA1(CryptoJs.enc.Utf8.parse(password));

        return CryptoJs.enc.Base64.stringify(pwdHash);
    }
}


async function loadSalesPointinfo(_user) {
    if (!_user)
        return null;

    var data = await DataSource.query('UserSalesPointAssociation', { filter: `UserId eq ${_user.UserId}`, userName: _user.UserName })

    if (data != null && data.length > 0 && data[0].SalesPointId) {

        var spData = await DataSource.load('SalesPoint', data[0].SalesPointId, { userName: _user.UserName })
        return spData;
    }
}

function isAdmin(_user) {
    if (_user.Roles.find(r => r.RoleId === "BO_ADMIN")) {
        return 'admin';
    }
    else {
        return null;
    }
}

function CreatePostUrl(controller, connectionName, version, entityName, authenticationToken, username) {
    let url = Configuration.serviceUrl + controller + '/' + connectionName + '/' + version;

    if (entityName) {
        url = url + '/' + entityName;
    }

    if (authenticationToken && username) {
        url = `${url}?authenticationToken=${authenticationToken}&username=${username}`;
    }

    return url;
}

function getErrorMessageFromResponse(error) {

    if (!error.response)
        return error.message;

    if (error.response.data && error.response.data.Message)
        return error.response.data.Message;

    if (error.response.status !== 200)
        return error.response.statusText;

    return this.errorNoResponseMessage;
}

/** 
 * Wraps an API call and handles common errors such as 
 * token expiration and token refresh
 * 
 * @param _func The function to wrap
 * @param _args An array containing the function arguments
*/
export async function secureApiCall(_func, ..._args) {
    
    var retry = false;
    var retryCount = 0;
    const maxRetries = 2;
    var error = null;
    var result = null;

    do {
        retryCount++;

        try {
            result = await _func.apply(null, _args);
        }
        catch (callError) {

            var message = getResponseMessage(callError);

            if (message === "RequestRefreshToken") {
                if (await refreshToken() && retryCount <= maxRetries) {
                    retry = true;
                }
                else {
                    retry = false;
                    SessionManager.expiredToken();
                }
            }
            else if (message === "LogoutUser") {
                retry = false;
                SessionManager.expiredToken();
            }
            else {
                retry = false;
                error = callError;
            }
        }
    } while (retry)

    if (error) {
        throw error;
    }
    else {
        saveNewRefressToken(result);
        return result;
    }
}

function getResponseMessage(error) {
    if (error.response && error.response.data && error.response.data.Message)
        return error.response.data.Message;
    else
        return null;
}

async function refreshToken() {

    try {
        const refreshTokenJsonInput = {
            username: SessionManager.userName,
            token: SessionManager.userRefreshToken
        };

        const webApiUrl = Configuration.serviceUrl;
        const connectionName = Configuration.connectionName;
        const version = Configuration.version;
        const url = `${webApiUrl}login/${connectionName}/${version}/refreshToken`;

        var response = await Axios.post(url, refreshTokenJsonInput);

        if (response.data != null) {
            localStorage.setItem('userToken', response.data);
            return true;
        }
        else {
            return false;
        }
    }
    catch (error) {
        return false;
    }
}

function saveNewRefressToken(data) {

    if (data && data.Token && data.refreshToken) {
        var token = SessionManager.userToken;
    
        var userToken = {
            token: token,
            refreshToken: data.Token.refreshToken
        };

        localStorage.setItem('userToken', JSON.stringify(userToken));
    }
}


export default SessionManager;